import { Picker } from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

import { useQueryParams } from "../../../hooks/useQueryParams";

export function ScoreFilter() {
  const { setParam, params } = useQueryParams();
  const { t } = useTranslation();

  return (
    <Picker
      showActionBar
      selectedKeys={params.report_result?.split(",") || []}
      onSelectionChange={(keys) => setParam("report_result", Array.from(keys))}
      label={t("Score")}
      items={[
        { id: "REVIEW", name: t("Review") },
        { id: "CLEAR", name: t("Clear") },
      ]}
      selectionMode="multiple"
      testID="score-filter"
    />
  );
}
